import * as React from 'react'
import cx from 'classnames'

const StepFooter: React.FunctionComponent<any> = ({ actions }: any) => {
  return <footer className={cx('step__footer')}>{actions}</footer>
}

export default StepFooter
